import {PageLayout, Heading, Spinner} from 'shared';

export function ContentPendingPage(): React.JSX.Element {
  return (
    <PageLayout.Main className="flex flex-col self-stretch">
      <PageLayout.Title>
        <Heading>&nbsp;</Heading>
      </PageLayout.Title>

      <PageLayout.Content className="flex grow items-center justify-center">
        <Spinner />
      </PageLayout.Content>
    </PageLayout.Main>
  );
}

ContentPendingPage.displayName = 'ContentPendingPage';
